/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { Suspense, useEffect, useState } from "react";
import * as THREE from "three";
import {
  Environment,
  Float,
  OrbitControls,
  SpotLight,
} from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import { useSpring, animated, config } from "@react-spring/three";
import { Balon1Model } from "./Balon1";
import { Balon2Model } from "./Balon2";
import { Balon3Model } from "./Balon3";
import Loader from "@components/Loader";
import { BaloonModel } from "./Balon";
import { BaloonJourneyModel } from "./BalonJourney";

export function BackgroundComponent({ page, scene }) {
  // const [color, setColor] = useState(0)
  // const [position, setPosition] = useState(0)

  // const Loading = () => {
  //   return (
  //     <div className='loading-journey-bg'>
  //       <Loader show={true} blackBg={true} />
  //     </div>
  //   )
  // }

  const scenesMap = [
    {
      color: "#F6B600",
      pages: [
        {
          baloon1Settings: {
            position: [-1, 0, 1],
            rotation: [1.8, 0, 0],
          },
          baloon2Settings: {
            position: [1.2, -3.6, 0],
            rotation: [1.8, 0, 0],
          },
          baloon3Settings: {
            position: [1.4, 0.3, 1],
            rotation: [1.8, 0, 0],
          },
          showBaloon: true,
        },
      ],
    },
    {
      color: "#00BDFF",
      pages: [
        {
          baloon1Settings: {
            position: [-4, 0, 0],
            rotation: [1.8, 0, 0],
          },
          baloon2Settings: {
            position: [-1, 0, 0],
            rotation: [1.8, 0, 0],
          },
          baloon3Settings: {
            position: [1.3, -1.8, 2],
            rotation: [1.5, 0.8, 0],
          },
        },
        {
          baloon1Settings: {
            position: [1.5, -1, 0],
            rotation: [1.8, Math.PI, 0],
          },
          baloon2Settings: {
            position: [-1, 0.5, 0],
            rotation: [1.8, 0, 0],
          },
          baloon3Settings: {
            position: [1, -2, 0],
            rotation: [1.8, Math.PI / 2, 0],
          },
        },
        {
          baloon1Settings: {
            position: [-4, 0, 0],
            rotation: [1.8, 0, 0],
          },
          baloon2Settings: {
            position: [1.1, -2, 0],
            rotation: [1.8, 0, 0],
          },
          baloon3Settings: {
            position: [4, 0, 0],
            rotation: [1.8, 0, 0],
          },
        },
        {
          baloon1Settings: {
            position: [-1, 3, 0],
            rotation: [1.8, Math.PI / 4, 0],
          },
          baloon2Settings: {
            position: [2, -0.2, 0],
            rotation: [1.8, Math.PI, 0],
          },
          baloon3Settings: {
            position: [4, 0, 0],
            rotation: [1.8, 0, 0],
          },
        },
      ],
    },
    {
      color: "#D5617B",
      pages: [
        {
          baloon1Settings: {
            position: [1.9, -1.6, 0],
            rotation: [1.8, Math.PI / 2, 0],
          },
          baloon2Settings: {
            position: [0, -2.6, 0],
            rotation: [1.8, 0, 0],
          },
          baloon3Settings: {
            position: [1.5, -2.2, 0],
            rotation: [1.8, Math.PI / 2, 0],
          },
        },
        {
          baloon1Settings: {
            position: [-0.3, 2.6, 0],
            rotation: [1.8, Math.PI / 3, 0],
          },
          baloon2Settings: {
            position: [1.6, 0, 0],
            rotation: [1.8, 0, 0],
          },
          baloon3Settings: {
            position: [-0.7, 0.6, 0],
            rotation: [1.8, Math.PI / 4, 0],
          },
        },
        {
          baloon1Settings: {
            position: [-4, 0, 0],
            rotation: [1.8, 0, 0],
          },
          baloon2Settings: {
            position: [-2, 1.8, 0],
            rotation: [1.8, 0, 0],
          },
          baloon3Settings: {
            position: [1.8, -0.2, 1],
            rotation: [1.5, 1.8, 0],
          },
        },
      ],
    },
    {
      color: "#58B269",
      pages: [
        {
          baloon1Settings: {
            position: [-4, 0, 0],
            rotation: [1.8, 0, 0],
          },
          baloon2Settings: {
            position: [0.8, 1.3, 0],
            rotation: [1.8, 0, 0],
          },
          baloon3Settings: {
            position: [0, 1.4, 1],
            rotation: [1.5, Math.PI / 2, 0],
          },
        },
        {
          baloon1Settings: {
            position: [-4, 0, 0],
            rotation: [1.8, 0, 0],
          },
          baloon2Settings: {
            position: [-0.6, 4.1, 0],
            rotation: [1.8, Math.PI / 1, 0],
          },
          baloon3Settings: {
            position: [4, -0.2, 1],
            rotation: [1.5, 1.8, 0],
          },
        },
        {
          baloon1Settings: {
            position: [1.9, -1.3, 0],
            rotation: [1.8, Math.PI / 2, 0],
          },
          baloon2Settings: {
            position: [-1.4, -3.5, 0],
            rotation: [1.8, 0, 0],
          },
          baloon3Settings: {
            position: [1.5, 3, 0],
            rotation: [1.8, Math.PI / 3, 0],
          },
        },
      ],
    },
    {
      color: "#F6B600",
      pages: [
        {
          baloon1Settings: {
            position: [-1, 2.6, 0],
            rotation: [1.8, Math.PI / 3, 0],
          },
          baloon2Settings: {
            position: [0.7, 1.4, 0],
            rotation: [1.8, 0, 0],
          },
          baloon3Settings: {
            position: [0.2, -0.6, 0],
            rotation: [1.8, Math.PI / 4, 0],
          },
        },
      ],
    },
  ];

  // const clickHandler = () => {
  //   if(position >= scenesMap[color].pages.length-1) {
  //     if(color >= scenesMap.length -1) {
  //       setColor(0)
  //       setPosition(0)
  //     } else {
  //       setColor(color+1)
  //       setPosition(0)
  //     }
  //   } else {
  //     setPosition(position+1)
  //   }
  // }

  const animateColor = useSpring({ color: scenesMap[scene].color });
  const animateBaloon1 = useSpring({
    position: scenesMap[scene].pages[page].showBaloon ? [0.5, 1, 0] : [5, 5, 0],
    config: config.slow,
  });
  const animate1Position = useSpring({
    position: scenesMap[scene].pages[page].baloon1Settings.position,
    config: config.slow,
  });
  const animate1Rotation = useSpring({
    rotation: scenesMap[scene].pages[page].baloon1Settings.rotation,
    config: config.slow,
  });
  const animate2Position = useSpring({
    position: scenesMap[scene].pages[page].baloon2Settings.position,
    config: config.slow,
  });
  const animate2Rotation = useSpring({
    rotation: scenesMap[scene].pages[page].baloon2Settings.rotation,
    config: config.slow,
  });
  const animate3Position = useSpring({
    position: scenesMap[scene].pages[page].baloon3Settings.position,
    config: config.slow,
  });
  const animate3Rotation = useSpring({
    rotation: scenesMap[scene].pages[page].baloon3Settings.rotation,
    config: config.slow,
  });

  // const animateColor = { color: scenesMap[scene].color }
  // const animate1Position = { position: scenesMap[scene].pages[page].baloon1Settings.position }
  // const animate1Rotation = { rotation: scenesMap[scene].pages[page].baloon1Settings.rotation }
  // const animate2Position = { position: scenesMap[scene].pages[page].baloon2Settings.position }
  // const animate2Rotation = { rotation: scenesMap[scene].pages[page].baloon2Settings.rotation }
  // const animate3Position = { position: scenesMap[scene].pages[page].baloon3Settings.position }
  // const animate3Rotation = { rotation: scenesMap[scene].pages[page].baloon3Settings.rotation }

  return (
    <Canvas id="scene" gl={{ antialias: true }} resize={{ debounce: 0 }}>
      <Environment
        preset="studio"
        environmentIntensity={1.2}
        environmentRotation={[0, -1, 4]}
      />
      <OrbitControls />
      <color attach="background" args={["#000"]} />
      {/* <fog attach="fog" args={['#000', 6, 10]} /> */}
      <ambientLight intensity={0.015} />
      <Float
        speed={2}
        rotationIntensity={3}
        floatIntensity={1}
        floatingRange={[-8, 8]}
      >
        <animated.spotLight
          castShadow
          penumbra={1}
          distance={30}
          angle={0.55}
          attenuation={1}
          anglePower={4}
          intensity={10}
          color={animateColor.color}
          position={[1, 0, 6]}
        />
      </Float>
      <Float
        speed={1}
        rotationIntensity={1}
        floatIntensity={1}
        floatingRange={[-10, 10]}
      >
        <animated.spotLight
          castShadow
          penumbra={1}
          distance={30}
          angle={0.55}
          attenuation={1}
          anglePower={4}
          intensity={10}
          color={animateColor.color}
          position={[0, 0, 6]}
        />
      </Float>
      <BaloonJourneyModel
        rotation={[Math.PI / 2, 0, 0]}
        bPosition={animateBaloon1.position}
      />
      <Balon1Model
        castShadow
        receiveShadow
        scale={0.1}
        color={animateColor.color}
        bPosition={animate1Position.position}
        bRotation={animate1Rotation.rotation}
      />
      <Balon2Model
        castShadow
        receiveShadow
        scale={0.1}
        color={animateColor.color}
        bPosition={animate2Position.position}
        bRotation={animate2Rotation.rotation}
      />
      <Balon3Model
        castShadow
        receiveShadow
        scale={0.1}
        color={animateColor.color}
        bPosition={animate3Position.position}
        bRotation={animate3Rotation.rotation}
      />
      <Float
        speed={2}
        rotationIntensity={3}
        floatIntensity={1}
        floatingRange={[-2, 2]}
      >
        <mesh receiveShadow position={[0, 0, -2]}>
          <planeGeometry args={[40, 60]} />
          <meshPhongMaterial />
        </mesh>
      </Float>
    </Canvas>
  );
}
